import $http from '../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Crear seguridad de proceso
 * @param payload: company_id, slq_location_id, type, description, file
 * @autor Paul Valencia
 */
export async function createProcessSecurity({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`process_security`, payload);
        return response;
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Buscar seguridad de proceso
 * @param payload: company_id, slq_location_id, type
 * @returns {Promise} orden actualizada
 * @autor Paul Valencia
 */
export async function searchProcessSecurity({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`process_security`, {params: payload});
        commit('setProcessSecurity', response.data);
        return response.data.length
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Descarga la imagen del adjunto.
 *
 * @param data: id, company_id
 * @autor Paul Valencia
 * @returns void
 */
export async function downloadFile({commit}, data) {
    commit('dashboard/load', true, {root: true});
    await $http({
        url: data.url,
        method: 'POST',
        responseType: 'blob',
        data
    }).then((response) => {
        commit('dashboard/load', false, {root: true});
        const file = data.file;
        window.downloadFile(response.data, file)
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'No se encontro el archivo',
            showConfirmButton: true,
            timer: 5000
        });
    });
}


/**
 * Descarga la imagen del adjunto.
 *
 * @param data: id, company_id
 * @autor Paul Valencia
 * @returns void
 */
export async function downloadFileHistory({commit}, data) {
    commit('dashboard/load', true, {root: true});
    await $http({
        url: 'process_security_downloadFile_history',
        method: 'POST',
        responseType: 'blob',
        data
    }).then((response) => {
        commit('dashboard/load', false, {root: true});
        const file = data.url;
        window.downloadFile(response.data, file)
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.error,
            showConfirmButton: true,
            timer: 5000
        });
    });
}


/**
 * Buscar detalle de seguridad de proceso
 * @param payload: company_id, id,
 * @autor Paul Valencia
 */
export async function show({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`process_security/${payload.id}/details`, {params: payload});
        response.data.file = null;
        commit('setDetails', response.data);
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Actualizar seguridad de proceso.
 * @param payload: company_id, slq_location_id, type, description, file
 * @autor Paul Valencia
 */
export async function updateProcessSecurity({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`process_security/${payload.get('id')}/update`, payload);
        return Promise.resolve(response);
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Cambiar el estado de un adjunto a inactivo para simular la eliminación.
 *
 * @param payload: id, company_id
 * @autor Paul Valencia
 * @returns company_id
 */
export async function deleteProcess(context, {id, company_id}) {

    await $http.patch(`process_security/${id}/delete`, {company_id}).then(async (response) => {
        await Swal.fire({
            position: 'center',
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 2000
        });

    }).catch(async (error) => {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    });
}


/**
 * Crear politicas prevencion
 * @param payload: company_id, slq_location_id, type, description, file
 * @autor Paul Valencia
 */
export async function createPrSecPreventionPolicy({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`pr_sec_prevention_policies`, payload);
        return response;
    } catch (error) {
        if (error.code == 422 && error.message && error.message.type.length) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message.type[0],
                showConfirmButton: false,
                timer: 2000
            });
            return;
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Buscar seguridad de proceso
 * @param payload: company_id, slq_location_id, type
 * @returns {Promise} orden actualizada
 * @autor Paul Valencia
 */
export async function searchPrSecPreventionPolicy({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`pr_sec_prevention_policies`, {params: payload});
        commit('setPrSecPreventionPolicy', response.data);
        return response.data.length
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Buscar detalle de seguridad de proceso
 * @param payload: company_id, id,
 * @autor Paul Valencia
 */
export async function showPreventionPolicy({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`pr_sec_prevention_policies/${payload.id}/details`, {params: payload});
        response.data.file = null;
        commit('setDetailsPreventionPolicy', response.data);
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Actualizar seguridad de proceso.
 * @param payload: company_id, slq_location_id, type, description, file
 * @autor Paul Valencia
 */
export async function updatePreventionPolicy({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`pr_sec_prevention_policies/${payload.get('id')}/update`, payload);
        return response
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Descarga la imagen del adjunto.
 *
 * @param data: id, company_id
 * @autor Paul Valencia
 * @returns void
 */
export async function downloadFileHistoryPrevPoli({commit}, data) {
    commit('dashboard/load', true, {root: true});
    await $http({
        url: 'pr_sec_prevention_policies_downloadFile_history',
        method: 'POST',
        responseType: 'blob',
        data
    }).then((response) => {
        commit('dashboard/load', false, {root: true});
        const file = data.url;
        window.downloadFile(response.data, file)
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.error,
            showConfirmButton: true,
            timer: 5000
        });
    });
}


/**
 * Obtener los adjuntos por ubicación.
 * @param payload: company_id, slq_location_id
 * @autor Paul Valencia
 */
export async function getProductsAttachmentsByLocation({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`process_security_safety_data_sheets`, {params: payload});
        commit('setAttachments', response.data);
        return response.data.length;
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }

    } finally {
        commit('dashboard/load', false, {root: true});
    }

}


/**
 * Obtener los productos con adjuntos pdf por ubicación.
 * @param payload: company_id, slq_location_id
 * @autor Paul Valencia
 */
export async function getProductsByLocationPdf({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`process_security_safety_data_pdf`, {params: payload});
        commit('setPrSecPreventionPolicy', response.data);
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }

    } finally {
        commit('dashboard/load', false, {root: true});
    }
}

/**
 * Buscador multiple para las consultas dependiendo desde en el módulo en que se realice
 * Se incorpora dentro de los actións para evitar duplicidad de código ya qué este se ejecuta en el
 * módulo FormSearch cuando se cambia la ubicacion o en el módulo principal cuando se cambia de componente.
 * @param payload: type
 * @returns mix
 * @autor Paul Valencia
 */
export async function searchInfo({state, dispatch}, type) {
    if (!state.filter.company_id || !state.filter.slq_location_id) return;
    if (state.modulesOnlyFile.includes(type) || type === 'política') {
        await dispatch('searchPrSecPreventionPolicy', state.filter);
    } else if (type === 'información de seguridad - soluquim') {
        await dispatch('getProductsAttachmentsByLocation', state.filter);
    } else if (type === 'fichas-seguridad') {
        await dispatch('getProductsByLocationPdf', state.filter);
    } else {
        await dispatch('searchProcessSecurity', state.filter);
    }
}


/**
 * Descarga la imagen del adjunto.
 *
 * @param data: id, company_id
 * @autor Paul Valencia
 * @returns void
 */
export async function downloadAttachment({commit}, data) {
    commit('dashboard/load', true, {root: true});
    await $http({
        url: `adm_productos/adjuntos/download/${data.id}`,
        method: 'POST',
        responseType: 'blob',
        data
    }).then((response) => {
        commit('dashboard/load', false, {root: true});
        const file = data.file;
        window.downloadFile(response.data, `adjunto_${data.id}`, `.${data.extension}`)
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.error,
            showConfirmButton: true,
            timer: 5000
        });
    });
}


/**
 * Buscador para mostrar los porcentajes de los diferentes modulos de seguridad de procesos.
 * @param payload: type
 * @returns mix
 * @autor Paul Valencia
 */
export async function searchInfoByPercentaje({state, commit}, payload) {
    try{
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`process_security_general_percentage`, {params: payload});
        commit('setDataPercentage', response.data)
    }catch (e) {

    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Buscar detalle de seguridad de proceso
 * @param payload: company_id, id,
 * @autor Paul Valencia
 */
export async function getParametricsByModule({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`pr_sec_parametrics`, {params: payload});
        commit('setOptionsTypes', response.data);
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Guardar listado parametrico
 * @param payload: company_id, id,
 * @autor Paul Valencia
 */
export async function saveParametrics({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`pr_sec_parametrics`, payload);
        await Swal.fire({
            position: 'center',
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 2000
        });
    } catch (error) {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            text: error.errors.type[0],
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * eliminar listado parametrico
 * @param payload: company_id, id,
 * @autor Paul Valencia
 */
export async function destroyParametrics({commit}, id) {
    try {
        commit('dashboard/load', true, {root: true});
        await $http.patch(`pr_sec_parametrics/${id}/delete`);
        await Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Registro eliminado correctamente',
            showConfirmButton: false,
            timer: 2000
        });
    } catch (error) {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            text: error.errors.type[0],
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}

